import { render, staticRenderFns } from "./AIColourMatchModal.vue?vue&type=template&id=ae37ad6a&"
import script from "./AIColourMatchModal.vue?vue&type=script&lang=js&"
export * from "./AIColourMatchModal.vue?vue&type=script&lang=js&"
import style0 from "./AIColourMatchModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports